import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { FulfillmentPlanOrderGridStatus } from '../../enums/fulfillmentplan-order-grid-status';
import { useGetFulfillmentPlanDataForRestore } from '../../hooks/entities/selectors/fulfillment-plans';
import { restoreSingleShipment } from '../../store/orders/orders.api';
import { RestoreDropdownMenuItem } from './restore-dropdown-menu-item';
import { useEnableReship } from '../../feature-flags/hooks/use-enable-reship';

export const RestoreShippedDropdownMenuItem = ({ fulfillmentPlanId }) => {
  const { hasActiveFulfillments, orderGridStatus } = useGetFulfillmentPlanDataForRestore(fulfillmentPlanId);
  const restoreShippedShipmentApiCall = useCallback(() => {
    return restoreSingleShipment(fulfillmentPlanId);
  }, [fulfillmentPlanId]);

  const isReshipEnabled = useEnableReship();
  const isRestorable = !isReshipEnabled && !hasActiveFulfillments && orderGridStatus === FulfillmentPlanOrderGridStatus.Shipped.name;

  return <RestoreDropdownMenuItem apiCall={restoreShippedShipmentApiCall} isDisabled={!isRestorable} />;
};

RestoreShippedDropdownMenuItem.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};
